import queryFn from "ApiLayer/Reports/Recommendations/queryAverageMarginalAbatementCostByMeasureCategoryChart";
import { useAccessToken } from "hooks/useAccessToken";
import { useQuery } from "react-query";
import { QUERY_STALE_TIME } from "utils/constants";

export const useAverageMarginalAbatementCostByMeasureCategoryChart = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["averageMarginalAbatementCostByMeasureCategoryChart", filtersetUid],
        queryFn: async () => queryFn(accessToken, { reportFiltersetUid: filtersetUid }),
        staleTime: QUERY_STALE_TIME,
    });
};
